import './index.scss'
import AnimatedLetters from '../AnimatedLetters'
import { useEffect, useState } from 'react'
import Loader from 'react-loaders'

const Privacy = () => {
    const [letterClass, setLetterClass] = useState('text-animate')

    useEffect(() => {
        setTimeout(() => {
            setLetterClass('text-animate-hover')
        }, 3000)
    }, [])

    return (
        <>
            <div className="container privacy-page">
                <div className="text-zone">
                    <h1>
                        <AnimatedLetters
                            letterClass={letterClass}
                            strArray={['P', 'r', 'i', 'v', 'a', 'c', 'y', ' ', 'P', 'o', 'l', 'i', 'c', 'y']}
                            idx={15}
                        />
                    </h1>

                    <div className="privacy-content">
                        <h3>VERMILION RESEARCH LLC</h3>
                        <p><strong>Effective Date:</strong> 6.7.2025 | <strong>Last Updated:</strong> 7.13.2025</p>

                        <h2>1. INTRODUCTION</h2>
                        <p>Vermilion Research LLC ("Company," "we," "us," or "our") respects your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our mobile applications, machine learning services, and robotics solutions.</p>

                        <h2>2. INFORMATION WE COLLECT</h2>

                        <h3>2.1 Personal Information</h3>
                        <p>We may collect personal information that you voluntarily provide, including:</p>
                        <ul>
                            <li>Contact information (name, email, phone number)</li>
                            <li>Professional information (company, job title)</li>
                            <li>Communication preferences</li>
                        </ul>

                        <h3>2.2 Automatically Collected Information</h3>
                        <p>When you use our services, we may automatically collect:</p>
                        <ul>
                            <li><strong>Location Data:</strong> GPS coordinates, geolocation information</li>
                            <li><strong>Usage Data:</strong> Time stamps, session duration, interaction patterns</li>
                            <li><strong>Device Information:</strong> Device type, operating system, unique device identifiers</li>
                            <li><strong>Performance Data:</strong> Speed, acceleration, movement patterns</li>
                            <li><strong>Technical Data:</strong> IP address, browser type, app version</li>
                        </ul>

                        <h3>2.3 Sensor Data</h3>
                        <p>Our mobile applications may collect data from device sensors, including:</p>
                        <ul>
                            <li>Accelerometer and gyroscope data</li>
                            <li>GPS and location services</li>
                            <li>Camera and image data (when applicable)</li>
                            <li>Microphone data (when applicable)</li>
                        </ul>

                        <h2>3. HOW WE USE YOUR INFORMATION</h2>
                        <p>We use collected information for:</p>
                        <ul>
                            <li><strong>Machine Learning Model Training:</strong> Developing and improving AI algorithms</li>
                            <li><strong>Service Improvement:</strong> Enhancing our mobile apps and robotics solutions</li>
                            <li><strong>Research and Development:</strong> Advancing our technological capabilities</li>
                            <li><strong>Performance Analysis:</strong> Understanding usage patterns and system performance</li>
                            <li><strong>Communication:</strong> Responding to inquiries and providing support</li>
                            <li><strong>Legal Compliance:</strong> Meeting regulatory requirements</li>
                        </ul>

                        <h2>4. DATA SHARING AND DISCLOSURE</h2>
                        <h3>4.1 Third-Party Service Providers</h3>
                        <p>We may share information with trusted third-party service providers who assist us in:</p>
                        <ul>
                            <li>Data processing and analysis</li>
                            <li>Cloud storage and computing services</li>
                            <li>Technical support and maintenance</li>
                        </ul>

                        <h3>4.2 Legal Requirements</h3>
                        <p>We may disclose information when required by law, regulation, or legal process, or to protect our rights and safety.</p>

                        <h3>4.3 Business Transfers</h3>
                        <p>In the event of a merger, acquisition, or sale of assets, your information may be transferred to the acquiring entity.</p>

                        <h2>5. DATA RETENTION</h2>
                        <p>We retain personal information for as long as necessary to fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required by law. Data used for machine learning model training may be retained indefinitely in aggregated and anonymized form.</p>

                        <h2>6. DATA SECURITY</h2>
                        <p>We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet or electronic storage is 100% secure.</p>

                        <h2>7. YOUR RIGHTS AND CHOICES</h2>
                        <h3>7.1 Access and Control</h3>
                        <p>You may request access to, correction of, or deletion of your personal information by contacting us using the information provided below.</p>

                        <h3>7.2 Location Data</h3>
                        <p>You can disable location services for our mobile applications through your device settings, though this may limit functionality.</p>

                        <h3>7.3 Opt-Out</h3>
                        <p>You may opt out of certain data collection practices by adjusting your device settings or contacting us directly.</p>

                        <h2>8. CHILDREN'S PRIVACY</h2>
                        <p>Our services are not intended for children under 13 years of age. We do not knowingly collect personal information from children under 13.</p>

                        <h2>9. CALIFORNIA PRIVACY RIGHTS</h2>
                        <p>If you are a California resident, you have additional rights under the California Consumer Privacy Act (CCPA):</p>
                        <ul>
                            <li>Right to know what personal information is collected</li>
                            <li>Right to delete personal information</li>
                            <li>Right to opt-out of the sale of personal information</li>
                            <li>Right to non-discrimination for exercising these rights</li>
                        </ul>

                        <h2>10. INTERNATIONAL DATA TRANSFERS</h2>
                        <p>Your information may be transferred to and processed in countries other than your country of residence. We ensure appropriate safeguards are in place for such transfers.</p>

                        <h2>11. COOKIES AND SIMILAR TECHNOLOGIES</h2>
                        <p>Currently, we do not use cookies or similar tracking technologies. If this changes in the future, we will update this Privacy Policy accordingly.</p>

                        <h2>12. CHANGES TO THIS PRIVACY POLICY</h2>
                        <p>We may update this Privacy Policy from time to time. We will notify you of any material changes by posting the new Privacy Policy on our website or through our mobile applications.</p>

                        <h2>13. CONTACT INFORMATION</h2>
                        <p>For questions about this Privacy Policy or to exercise your rights, please contact:</p>
                        <p>
                            <strong>Vermilion Research LLC</strong><br />
                            Chicago, IL<br />
                            <a href="mailto:info@vermresearch.com">info@vermresearch.com</a><br />
                            (312) 285-0552
                        </p>
                        <p className="note">For California residents exercising CCPA rights, please specify "CCPA Request" in your communication.</p>
                        <br /><br />
                    </div>
                </div>
            </div>
            <Loader type="ball-scale-multiple" />
        </>
    )
}

export default Privacy
